<!-------------------- Introduction section -------------------->
<section class="introduction-section">
  <div class="introduction-container">
    <div class="overlay"></div>
    <div class="intro-content">
      <h1>Empower Your University with<br />Data-Driven Insights</h1>
      <h2>A Smarter Platform for Administrators, Advisors, and Students</h2>
      <p>
        Managing a university is complex, but with our cutting-edge platform,
        you can make informed decisions that improve student success, optimize
        academic programs, and streamline administrative tasks—all in one place.
      </p>
      <a href="#" class="btn">Contact PAMLab</a>
    </div>
  </div>
</section>

<!-------------------- Dashboard selling points section -------------------->
<section class="dashboard-benefits">
  <div class="content-wrapper">
    <h2>Why Choose Our Platform?</h2>
    <div class="benefits-list">
      <div class="benefit">
        <i class="fa-solid fa-square-check check-icon"></i>
        <div class="dashboard-desc">
          Boost Student Success – Identify at-risk students, predict course
          performance, and recommend the best academic paths.
        </div>
        <i class="fa-solid fa-users-rectangle big-icon"></i>
      </div>

      <div class="benefit">
        <i class="fa-solid fa-square-check check-icon"></i>
        <div class="dashboard-desc">
          Optimize Course Offerings – Identify bottleneck courses, analyze
          prerequisite impacts, and improve curriculum planning.
        </div>
        <i class="fa-solid fa-microscope big-icon"></i>
      </div>

      <div class="benefit">
        <i class="fa-solid fa-square-check check-icon"></i>
        <div class="dashboard-desc">
          Enhance Administrative Efficiency – Track enrollment trends, retention
          rates, and graduation metrics with real-time data.
        </div>
        <i class="fa-solid fa-chart-line big-icon"></i>
      </div>

      <div class="benefit">
        <i class="fa-solid fa-square-check check-icon"></i>
        <div class="dashboard-desc">
          Make Data-Driven Decisions – Get powerful visualizations and reports
          to help students and administrators excel.
        </div>
        <i class="fa-solid fa-database big-icon"></i>
      </div>
    </div>
  </div>
</section>

<!-------------------- Boost Student Success section -------------------->
<div class="success-metrics">
  <div class="section-header">
    <h2>
      Boost Student Success – Identify at-risk students, predict course
      performance, and recommend the best academic paths.
    </h2>
  </div>

  <div class="toggle-buttons">
    <button
      *ngFor="let card of successMetricsCards; let i = index"
      (click)="selectSuccessMetricsCard(i)"
      [class.active]="i === currentCardSuccess"
    >
      {{ card }}
    </button>
  </div>

  <div class="card">
    <ng-container [ngSwitch]="currentCardSuccess">
      <!-- 1. Student Profile -->
      <div class="metric-card half-width-card" *ngSwitchCase="0">
        <h3>Student Profile and At-Risk Identification:</h3>
        <p>
          Detect struggling students early for proactive intervention by gaining
          insights into student performance.
        </p>
        <!-- <img
          src="../../../../assets/uwf_assets/marketing-page-pics/student_bubbles.png"
          alt="Student Profile"
        /> -->

        <div class="student-table">
          <!-- Student 1 -->
          <div class="student-card">
            <div class="tables">
              <div class="table-block">
                <table>
                  <thead>
                    <tr>
                      <th>Student ID</th>
                      <th>Program</th>
                      <th>GPA</th>
                      <th>Current Term Load</th>
                      <th>Current Progress Standing</th>
                      <th>Dropout Risk</th>
                      <th>Dropout Risk Reasons</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>1001</td>
                      <td>Art</td>
                      <td>3.90</td>
                      <td>12</td>
                      <td>Unsatisfactory</td>
                      <td>Low</td>
                      <td>N/A</td>
                    </tr>
                    <tr>
                      <td>1002</td>
                      <td>Accounting</td>
                      <td>1.84</td>
                      <td>9</td>
                      <td>Good</td>
                      <td>High</td>
                      <td>Low GPA</td>
                    </tr>
                    <tr>
                      <td>1003</td>
                      <td>Elementary Education</td>
                      <td>3.38</td>
                      <td>13</td>
                      <td>Good</td>
                      <td>Medium</td>
                      <td>Low Prior Hours</td>
                    </tr>
                    <tr>
                      <td>1004</td>
                      <td>Nursing</td>
                      <td>3.0</td>
                      <td>15</td>
                      <td>Moderate</td>
                      <td>Medium</td>
                      <td>High DWF Hours</td>
                    </tr>
                    <tr>
                      <td>1005</td>
                      <td>Physics</td>
                      <td>2.97</td>
                      <td>10</td>
                      <td>Good</td>
                      <td>Low</td>
                      <td>N/A</td>
                    </tr>
                    <tr>
                      <td>...</td>
                      <td>...</td>
                      <td>...</td>
                      <td>...</td>
                      <td>...</td>
                      <td>...</td>
                      <td>...</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 2. Cohort Profile -->
      <div class="metric-card half-width-card" *ngSwitchCase="1">
        <h3>Cohort Profile:</h3>
        <p>Gain insights into cohort performance.</p>
        <img
          class="cohort-pic"
          src="../../../../assets/uwf_assets/marketing-page-pics/aprGraduation.png"
          alt="Cohort Profile"
        />
      </div>

      <!-- 3. Course Recommender  -->
      <div class="metric-card half-width-card" *ngSwitchCase="2">
        <h3>Course Recommender:</h3>
        <p>
          Get personalized course recommendations based on past performance.
        </p>

        <div class="student-table">
          <!-- Student 1 -->
          <div class="student-card">
            <h3>Student ID: 100101</h3>
            <p>
              <strong>Program:</strong> Accounting |
              <strong>Recommender Semester:</strong> Fall 3
            </p>
            <div class="tables">
              <div class="table-block">
                <h4>Course History</h4>
                <table>
                  <thead>
                    <tr>
                      <th>Course Code</th>
                      <th>Course Name</th>
                      <th>Earned Grade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ACG2011</td>
                      <td>Financial Accounting 1</td>
                      <td>B-</td>
                    </tr>
                    <tr>
                      <td>MAN3053</td>
                      <td>Management Fundamentals</td>
                      <td>A</td>
                    </tr>
                    <tr>
                      <td>...</td>
                      <td>...</td>
                      <td>...</td>
                    </tr>
                    <tr>
                      <td>ACG2012</td>
                      <td>Managerial Accounting</td>
                      <td>B</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <mat-divider [vertical]="true"></mat-divider>
              <div class="table-block">
                <h4>Recommended Courses</h4>
                <table>
                  <thead>
                    <tr>
                      <th>Course Code</th>
                      <th>Course Name</th>
                      <th>Pass Rate</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>ACG3334</td>
                      <td>Cost Accounting</td>
                      <td>0.93</td>
                    </tr>
                    <tr>
                      <td>ISM2111</td>
                      <td>e-Business Fundamentals</td>
                      <td>0.93</td>
                    </tr>
                    <tr>
                      <td>ECO2032</td>
                      <td>Microeconomics</td>
                      <td>0.75</td>
                    </tr>
                    <tr>
                      <td>TAX4100</td>
                      <td>Taxation of Individuals</td>
                      <td>0.89</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 4. Course Grade Estimation  -->
      <div class="metric-card half-width-card" *ngSwitchCase="3">
        <h3>Course Grade Estimation:</h3>
        <p>Predict student performance in courses before enrollment.</p>
        <div class="student-table">
          <!-- Student 4 -->
          <div class="student-card">
            <h3>Student ID: 100104</h3>
            <p>
              <strong>Program:</strong> Electrical Engineering |
              <strong>Target Semester:</strong> Spring 2
            </p>
            <div class="tables">
              <div class="table-block">
                <h4>Course History</h4>
                <table>
                  <thead>
                    <tr>
                      <th>Course Code</th>
                      <th>Course Name</th>
                      <th>Earned Grade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>PHY2041</td>
                      <td>Physics 1</td>
                      <td>C-</td>
                    </tr>
                    <tr>
                      <td>PHY2041L</td>
                      <td>Physics 1 Lab</td>
                      <td>A</td>
                    </tr>
                    <tr>
                      <td>...</td>
                      <td>...</td>
                      <td>...</td>
                    </tr>
                    <tr>
                      <td>MAC2321</td>
                      <td>Calculus 2</td>
                      <td>C-</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <mat-divider [vertical]="true"></mat-divider>
              <div class="table-block">
                <h4>Courses Grade Estimation</h4>
                <table>
                  <thead>
                    <tr>
                      <th>Course Code</th>
                      <th>Course Name</th>
                      <th>Predicted Grade</th>
                      <th>Earned Grade</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>EGN3204</td>
                      <td>Engineering Tools</td>
                      <td>[C+, A-]</td>
                      <td>B-</td>
                    </tr>
                    <tr>
                      <td>PHY2042</td>
                      <td>Physics 2</td>
                      <td>[D, B-]</td>
                      <td>D</td>
                    </tr>
                    <tr>
                      <td>PHY2042L</td>
                      <td>Physics 2 Lab</td>
                      <td>[A, A]</td>
                      <td>A-</td>
                    </tr>
                    <tr>
                      <td>MAC2331</td>
                      <td>Calculus 3</td>
                      <td>[B-, A-]</td>
                      <td>B</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-------------------- Optimize Course Offerings section -------------------->

<div class="optimize-course-offerings">
  <div class="section-header">
    <h2>
      Optimize Course Offerings – Identify bottleneck courses, analyze
      prerequisite impacts, and improve curriculum planning.
    </h2>
  </div>

  <div class="toggle-buttons-dark">
    <button
      *ngFor="let card of optimizeCourseOfferingsCards; let i = index"
      (click)="selectOptimizeCourseOfferingsCard(i)"
      [class.active]="i === currentCardOptimize"
    >
      {{ card }}
    </button>
  </div>

  <div class="card">
    <ng-container [ngSwitch]="currentCardOptimize">
      <!-- 5. Program Bottleneck Detection -->
      <div class="metric-card half-width-card" *ngSwitchCase="0">
        <h3>Program Bottleneck Detection:</h3>
        <p>
          Identify courses with the lowest passing rates to enhance curriculum
          planning.
        </p>

        <div class="student-table">
          <div class="tables">
            <div class="table-block">
              <table>
                <thead>
                  <tr>
                    <th>College</th>
                    <th>Program</th>
                    <th>Year</th>
                    <th>Semester</th>
                    <th>Bottleneck Courses</th>
                    <th>Courses Name</th>
                    <th>Pass Rate</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>College of Science</td>
                    <td>Biology</td>
                    <td>Year 2</td>
                    <td>Fall</td>
                    <td>CHM2011</td>
                    <td>General Chemistry 1</td>
                    <td>0.41</td>
                  </tr>
                  <tr>
                    <td>College of Science</td>
                    <td>Biology</td>
                    <td>Year 3</td>
                    <td>Spring</td>
                    <td>PCB3100</td>
                    <td>Cell Biology</td>
                    <td>0.32</td>
                  </tr>
                  <tr>
                    <td>College of Business</td>
                    <td>Accounting</td>
                    <td>Year 2</td>
                    <td>Fall</td>
                    <td>ACG3001</td>
                    <td>Intermediate Financial Accounting 1</td>
                    <td>0.30</td>
                  </tr>
                  <tr>
                    <td>College of Business</td>
                    <td>Accounting</td>
                    <td>Year 3</td>
                    <td>Spring</td>
                    <td>ACG2012</td>
                    <td>Managerial Accounting</td>
                    <td>0.40</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <!-- 6. Analyze Prerequisite Impact -->
      <div class="metric-card half-width-card" *ngSwitchCase="1">
        <h3>Explore Course Combinations:</h3>
        <p>
          Use course combination insights to guide curriculum planning and
          improve student success through more strategic course pairing.
        </p>

        <div>
          <mat-button-toggle-group
            name="course-combos"
            aria-label="Course Combo Buttons"
            [(ngModel)]="selectedCourseCombo"
          >
            <!-- looping through button toggle for all courses -->
            <ng-container
              *ngFor="
                let courseCombo of [
                  '1 Course',
                  '2 Courses',
                  '3 Courses',
                  '4 Courses',
                  '5 Courses',
                ]
              "
            >
              <mat-button-toggle value="{{ courseCombo }}">
                {{ courseCombo }}
              </mat-button-toggle>
            </ng-container>
          </mat-button-toggle-group>
        </div>

        <div class="student-table">
          <!-- course combinations card -->
          <div class="student-card">
            <div class="tables">
              <div class="table-block">
                <ng-container [ngSwitch]="selectedCourseCombo">
                  <table *ngSwitchCase="'1 Course'">
                    <thead>
                      <tr>
                        <th>Course 1</th>
                        <th>Pass Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>ACG3101</td>
                        <td>0.61</td>
                      </tr>
                      <tr>
                        <td>MAC1105</td>
                        <td>0.72</td>
                      </tr>
                      <tr>
                        <td>CHM2045</td>
                        <td>0.79</td>
                      </tr>
                      <tr>
                        <td>PHY2048</td>
                        <td>0.68</td>
                      </tr>
                      <tr>
                        <td>...</td>
                        <td>...</td>
                      </tr>
                    </tbody>
                  </table>

                  <table *ngSwitchCase="'2 Courses'">
                    <thead>
                      <tr>
                        <th>Course 1</th>
                        <th>Course 2</th>
                        <th>Pass Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>ACG3101</td>
                        <td>ACG3343</td>
                        <td>0.56</td>
                      </tr>
                      <tr>
                        <td>MAC1105</td>
                        <td>GEB1101</td>
                        <td>0.79</td>
                      </tr>
                      <tr>
                        <td>CHM2045</td>
                        <td>EVR2920</td>
                        <td>0.93</td>
                      </tr>
                      <tr>
                        <td>PHY2048</td>
                        <td>EEL3701</td>
                        <td>0.41</td>
                      </tr>
                      <tr>
                        <td>...</td>
                        <td>...</td>
                        <td>...</td>
                      </tr>
                    </tbody>
                  </table>

                  <table *ngSwitchCase="'3 Courses'">
                    <thead>
                      <tr>
                        <th>Course 1</th>
                        <th>Course 2</th>
                        <th>Course 3</th>
                        <th>Pass Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>ACG3101</td>
                        <td>ACG3343</td>
                        <td>MAN3504</td>
                        <td>0.67</td>
                      </tr>
                      <tr>
                        <td>MAC1105</td>
                        <td>GEB1101</td>
                        <td>ENC1101</td>
                        <td>0.78</td>
                      </tr>
                      <tr>
                        <td>CHM2045</td>
                        <td>EVR2920</td>
                        <td>CHM2045L</td>
                        <td>0.88</td>
                      </tr>
                      <tr>
                        <td>PHY2048</td>
                        <td>EEL3701</td>
                        <td>MAC2312</td>
                        <td>0.33</td>
                      </tr>
                      <tr>
                        <td>...</td>
                        <td>...</td>
                        <td>...</td>
                        <td>...</td>
                      </tr>
                    </tbody>
                  </table>

                  <table *ngSwitchCase="'4 Courses'">
                    <thead>
                      <tr>
                        <th>Course 1</th>
                        <th>Course 2</th>
                        <th>Course 3</th>
                        <th>Course 4</th>
                        <th>Pass Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>ACG3101</td>
                        <td>ACG3343</td>
                        <td>MAN3504</td>
                        <td>FIN3403</td>
                        <td>0.76</td>
                      </tr>
                      <tr>
                        <td>MAC1105</td>
                        <td>ENC1101</td>
                        <td>ECO2013</td>
                        <td>SPC2608</td>
                        <td>0.65</td>
                      </tr>
                      <tr>
                        <td>CHM2045</td>
                        <td>CHM2045L</td>
                        <td>EEL48234</td>
                        <td>EGS1006</td>
                        <td>0.74</td>
                      </tr>
                      <tr>
                        <td>PHY2048</td>
                        <td>PHY2048L</td>
                        <td>MAC2312</td>
                        <td>CHM2990</td>
                        <td>0.67</td>
                      </tr>
                      <tr>
                        <td>...</td>
                        <td>...</td>
                        <td>...</td>
                        <td>...</td>
                        <td>...</td>
                      </tr>
                    </tbody>
                  </table>

                  <table *ngSwitchCase="'5 Courses'">
                    <thead>
                      <tr>
                        <th>Course 1</th>
                        <th>Course 2</th>
                        <th>Course 3</th>
                        <th>Course 4</th>
                        <th>Course 4</th>
                        <th>Pass Rate</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>AFR1101</td>
                        <td>CHM2045</td>
                        <td>CHM2045L</td>
                        <td>EGS1006</td>
                        <td>MAC1147</td>
                        <td>0.69</td>
                      </tr>
                      <tr>
                        <td>MAC1105</td>
                        <td>BSC1085</td>
                        <td>BSC1085L</td>
                        <td>DEP2004</td>
                        <td>ENC1101</td>
                        <td>0.65</td>
                      </tr>
                      <tr>
                        <td>CHM2045</td>
                        <td>CHM2045L</td>
                        <td>EEL48234</td>
                        <td>EGS1006</td>
                        <td>MAC2311</td>
                        <td>0.63</td>
                      </tr>
                      <tr>
                        <td>PHY2048</td>
                        <td>PHY2048L</td>
                        <td>MAC2312</td>
                        <td>CHM2045</td>
                        <td>CHM2045L</td>
                        <td>0.5</td>
                      </tr>
                      <tr>
                        <td>...</td>
                        <td>...</td>
                        <td>...</td>
                        <td>...</td>
                        <td>...</td>
                        <td>...</td>
                      </tr>
                    </tbody>
                  </table>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 7. Explore Course Combinations -->
      <div class="metric-card half-width-card" *ngSwitchCase="2">
        <h3>Analyze Prerequisite Impact:</h3>
        <p>
          Better understand course dependencies and view the impact
          prerequisites has on target courses.
        </p>
        <div>
          <mat-button-toggle-group
            name="prereqs"
            aria-label="Prereq Buttons"
            [(ngModel)]="selectedPrereq"
          >
            <!-- looping through button toggle for all courses -->
            <ng-container *ngFor="let prereq of targetCourseData.prereqs">
              <mat-button-toggle
                value="{{ prereq.course_code }}"
                (click)="showChart(prereq.course_code)"
              >
                {{ prereq.course_code }}
              </mat-button-toggle>
            </ng-container>
          </mat-button-toggle-group>
        </div>
        <app-prerequisite-chart
          [displayData]="selectedPrereqCourse"
          [targetCrs]="targetCourseData.target"
          [showLabels]="false"
        >
        </app-prerequisite-chart>
      </div>
    </ng-container>
  </div>
</div>

<!-------------------- Admin Support Tools section -------------------->
<div class="admin-support">
  <div class="overlay-admin"></div>

  <div class="section-header">
    <h2 style="color: white">
      Enhance Administrative Efficiency – Track enrollment trends, retention
      rates, and graduation metrics with real-time data.
    </h2>
  </div>

  <div class="toggle-buttons">
    <button
      *ngFor="let card of adminSupportCards; let i = index"
      (click)="selectAdminSupportCard(i)"
      [class.active]="i === currentCardAdmin"
    >
      {{ card }}
    </button>
  </div>

  <div class="card">
    <ng-container [ngSwitch]="currentCardAdmin">
      <!-- Top Left Box -->
      <div class="support-card" *ngSwitchCase="0">
        <h3>APR/Graduation/Summary:</h3>
        <p>
          Gain a holistic view of enrollment, retention, graduation rates, and
          academic progress.
        </p>
        <img
          src="../../../../assets/uwf_assets/marketing-page-pics/apr-graduation.png"
          alt="APR Chart"
        />
      </div>

      <!-- Top Right Box -->
      <div class="support-card" *ngSwitchCase="1">
        <h3>Entry or Exit Flow Graph:</h3>
        <p>
          Analyze student entry and exit trends based on college, department,
          and program after the first year.
        </p>
        <div>
          <mat-button-toggle-group
            name="entry-exit"
            aria-label="Entry/Exit Buttons"
            [(ngModel)]="selectedEntryExit"
          >
            <!-- looping through button toggle for all courses -->
            <ng-container *ngFor="let entryExit of entryExitMap | keyvalue">
              <mat-button-toggle value="{{ entryExit.key }}">
                {{ entryExit.key }}
              </mat-button-toggle>
            </ng-container>
          </mat-button-toggle-group>
        </div>
        <img
          [src]="entryExitMap[selectedEntryExit]"
          alt="Entry/Exit Flow Graph"
        />
      </div>

      <!-- Bottom Left Box -->
      <div class="support-card" *ngSwitchCase="2">
        <h3>FTIC Course DWF & APR:</h3>
        <p>
          Identify top-enrolled FTIC courses by program and evaluate course pass
          and fail rates.
        </p>
        <img
          src="../../../../assets/uwf_assets/marketing-page-pics/ftic-course-chart.png"
          alt="FTIC Course DWF & APR"
        />
      </div>

      <!-- Bottom Right Box -->
      <div class="support-card" *ngSwitchCase="3">
        <h3>Transfer Enrollment & Trends:</h3>
        <p>
          Track enrollment patterns, retention rates, and student performance
          for transfer students.
        </p>
        <img
          src="../../../../assets/uwf_assets/marketing-page-pics/enrollment-trends-chart.png"
          alt="Transfer Enrollment & Trends"
        />
      </div>
    </ng-container>
  </div>
</div>

<!-------------------- Make Data-Driven Decisions section -------------------->
<section class="make-data-driven-decisions">
  <div class="section-header" style="margin-bottom: 0px">
    <h2>
      Make Data-Driven Decisions – Get powerful visualizations and reports to
      help students and administrators excel.
    </h2>
  </div>

  <!-- <div class="toggle-buttons-dark">
    <button
      *ngFor="let card of makeDataDrivenDecisionsCards; let i = index"
      (click)="selectMakeDataDrivenDecisionsCard(i)"
      [class.active]="i === currentCardMake"
    >
      {{ card }}
    </button>
  </div> -->

  <div class="card">
    <ng-container [ngSwitch]="currentCardMake">
      <!-- 12. New Applicant -->
      <div class="metric-card" *ngSwitchCase="0">
        <h3>Data Visualization:</h3>
        <p>View informed graphics on selected attributes.</p>
        <form
          [formGroup]="customChartForm"
          style="display: flex; gap: 20px; text-align: center"
        >
          <mat-form-field class="student-field-dropdown">
            <mat-label>X-axis</mat-label>
            <mat-select
              formControlName="xaxis"
              required
              (selectionChange)="handleCustomChartXaxisUpdate($event)"
            >
              @for (
                obj of customChartForm.value.filteredXaxisAttrs;
                track obj
              ) {
                <mat-option [value]="obj.columnProp">{{ obj.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="student-field-dropdown">
            <mat-label>Attribute</mat-label>
            <mat-select
              formControlName="attribute"
              (selectionChange)="handleCustomChartAttributeUpdate($event)"
            >
              <mat-option>None</mat-option>
              @for (obj of customChartForm.value.filteredAttrAttrs; track obj) {
                <mat-option [value]="obj.columnProp">{{ obj.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field class="student-field-dropdown">
            <mat-label>Group</mat-label>
            <mat-select
              formControlName="group"
              (selectionChange)="handleCustomChartGroupUpdate($event)"
            >
              <mat-option>None</mat-option>
              @for (
                obj of customChartForm.value.filteredGroupAttrs;
                track obj
              ) {
                <mat-option [value]="obj.columnProp">{{ obj.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </form>

        <div id="landing-page-custom-chart"></div>
      </div>

      <!-- 13. Critical Course Score -->
      <div class="metric-card" *ngSwitchCase="1">
        <h3>Critical Course Score:</h3>
        <p>Determine the best time to take crucial courses.</p>
        <img
          src="../../../../assets/uwf_assets/marketing-page-pics/critical-course-score.png"
          alt="Critical Course Score"
        />
      </div>

      <!-- 14. Three Year Graduation Rate -->
      <div class="metric-card" *ngSwitchCase="2">
        <h3>Three Year Graduation Rate:</h3>
        <p>Predict on-time graduation probabilities for transfer students.</p>
        <img
          src="../../../../assets/uwf_assets/marketing-page-pics/three_year_graduation_rate.png"
          alt="Three Year Graduation Rate"
        />
      </div>
    </ng-container>
  </div>
</section>

<section class="pam-section">
  <div class="pam-container">
    <h2>About the PAMLab – The Innovators Behind the Platform</h2>

    <div class="pam-image">
      <img
        src="../../../../assets/uwf_assets/marketing-page-pics/Pamlab_desc.png"
        alt="PAMLab illustration"
      />
    </div>

    <div class="pam-content">
      <p>
        The Predictive Analytics and Modeling (PAM) Lab (PAMLab) specializes in
        developing intuitive and impactful analytics for decision-making and
        predictive modeling. As a leader in data-driven innovation, the PAMLab
        empowers universities, businesses, and organizations to make informed
        decisions through cutting-edge data science solutions.
      </p>

      <p>
        Our flagship product—the Student Success Platform—is revolutionizing
        higher education by providing institutions with a comprehensive,
        data-driven view of student and institutional health. By seamlessly
        integrating data from multiple sources, including demographics, course
        performance, and advising notes, universities can personalize
        interventions, improve retention rates, and enhance overall student
        success.
      </p>

      <p>
        Beyond education, the PAMLab extends its expertise to businesses across
        various industries, helping organizations optimize operations, enhance
        strategic planning, and gain a competitive edge through data-informed
        decision-making. Whether you're looking to improve student outcomes or
        leverage predictive analytics for business growth, the PAMLab is your
        trusted partner in turning data into actionable insights.
      </p>
    </div>
  </div>
</section>

<section class="insights-section">
  <div class="insights-container">
    <h2>— Optimize Higher Education with Smart Insights —</h2>

    <div class="subtext-container">
      <p class="subtext">
        <i class="fa-solid fa-person"></i><i class="fa-solid fa-person"></i>
        Join universities that are already using our platform to drive student
        success and improve administrative efficiency!
      </p>

      <p class="subtext">
        <i class="fa-solid fa-calendar-days"></i>
        Schedule a Demo Today
      </p>
    </div>

    <div class="contact-box">
      <h3>Contact Us <i class="fa-solid fa-envelope"></i></h3>

      <form>
        <label>Name:</label>
        <input type="text" placeholder="Enter your name" />

        <label>Email:</label>
        <input type="email" placeholder="Enter your email" />

        <label>Phone:</label>
        <input type="text" placeholder="Enter your phone" />

        <label>Message:</label>
        <textarea placeholder="Enter your message"></textarea>

        <button type="submit">Submit</button>
      </form>
    </div>
  </div>
</section>
